import { toast } from 'react-toastify';
import { generateOtp } from '../apiServices/apiServices';

export const generateOtpMethod = async (generateOtpRequest) => {
  try {
    const response = await generateOtp(generateOtpRequest);
    // console.log("OTP Generated Response:", response);
    if (response && response.success) {
      toast.success(response.message);
    } else {
      toast.error(response?.message || 'Failed to generate OTP.');
    }
  } catch (error) {
    console.error('OTP not generated Error:', error);
    toast.error('An error occurred. Please try again.');
  }
};
